export default __webpack_public_path__ + "57980f1fc49cc1dceeda1907bab0f549.png";